import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const FadeContainer = ({ scrollbox, children, className }) => {
  const [scrolledToEnd, setScrolledToEnd] = useState(false);

  const cn = className ? `overflow-hidden relative ${className}` : `overflow-hidden relative`;

  const createFade =
    ({ maxScrollTop }) =>
    event => {
      const { scrollTop } = event.target;
      setScrolledToEnd(Math.abs(maxScrollTop - scrollTop) <= 5);
    };

  useEffect(() => {
    if (scrollbox) {
      const { scrollTop, scrollHeight, clientHeight } = scrollbox;
      const maxScrollTop = scrollHeight - clientHeight;
      setScrolledToEnd(Math.abs(maxScrollTop - scrollTop) <= 5);
      const fade = createFade({ maxScrollTop });
      scrollbox.addEventListener('scroll', fade);
      return () => {
        if (scrollbox) {
          scrollbox.removeEventListener('scroll', fade);
        }
      };
    }
    return undefined;
  }, [scrollbox, children]);

  return (
    <div data-component="FadeContainer" className={cn}>
      {children({ scrolledToEnd })}
    </div>
  );
};

FadeContainer.defaultProps = {
  className: '',
};

FadeContainer.propTypes = {
  scrollbox: PropTypes.instanceOf(Element),
  children: PropTypes.func,
  className: PropTypes.string,
};

export default FadeContainer;
